import React, {
  useEffect, useMemo, useRef
} from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Route from 'react/components/RouteMonitor/RoutesList/list/Route.jsx';
import { actionCreators } from 'react/api/actions/monitor';
import Loading from 'react/components/Loading';

function List({
  cardViewMode
}) {
  const {
    routes,
    filter,
    footer,
    routeMonitor: {
      isRequestingRoutes
    }
  } = useSelector((state) => state);
  const miniDashboardIsOpen = footer.get('miniDashboardIsOpen');

  const {
    endDate,
    organizationId,
    queryParameter,
    startDate,
    status,
    firstResult,
    maxResult
  } = filter;
  const filterContainerRef = useRef(null);
  let containerClassName = miniDashboardIsOpen ? ' miniDashboardIsOpen' : '';

  containerClassName = cardViewMode === 'compact' ? `${containerClassName} compact` : containerClassName;

  useEffect(() => {
    window.globalStore.dispatch(
      actionCreators.request({ ...filter, firstResult: 0 })
    );
  }, []);

  const hasFilterList = useMemo(() => {
    const hasStatus = !!status && status.length > 0;
    return (endDate || organizationId || queryParameter || startDate || hasStatus);
  }, [filter]);

  const hasNotRouteAndHasFilter = routes.length === 0 && hasFilterList && !isRequestingRoutes;
  const hasNotRouteAndFilter = routes.length === 0 && !hasFilterList && !isRequestingRoutes;
  const hasRouteAndNotLoading = !isRequestingRoutes && routes.length > 0;

  useEffect(() => {
    const addScrollListener = (event) => {
      const scrollArea = event.target;
      const delta = scrollArea.scrollHeight
      - scrollArea.scrollTop
      - scrollArea.getBoundingClientRect().height;

      if (Math.floor(delta) <= 0) {
        window.globalStore.dispatch(
          actionCreators.paginate({
            ...filter,
            firstResult: firstResult + maxResult
          })
        );
      }
    };

    const container = document.querySelector('[data-testid="filter-body-container"]');

    if (routes?.length > 0 && container) {
      container.addEventListener('scroll', addScrollListener);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', addScrollListener);
      }
    };
  }, [routes, filter]);

  return (
    <div
      ref={filterContainerRef}
      data-testid="filter-body-container"
      className={`filterBodyContainer ${containerClassName}`}
    >
      {isRequestingRoutes && (
        <div data-testid="loading-routes" className="containerWarning">
          <Loading />
        </div>
      )}
      {hasRouteAndNotLoading && routes.map((route) => (
        <Route key={`route-${route.id}`} route={route} />
      ))}
      {hasNotRouteAndHasFilter && (
        <div className="containerWarning" data-testid="no-routes-with-filters">
          {Monet.I18n.getResourcesByKey('routeMonitor.routes.noRouteFilter.warning')}
        </div>
      )}
      {hasNotRouteAndFilter && (
        <div className="containerWarning" data-testid="no-routes">
          {Monet.I18n.getResourcesByKey('routeMonitor.routes.noRoute.warning')}
        </div>
      )}
    </div>
  );
}

List.propTypes = {
  cardViewMode: PropTypes.string.isRequired
};

export default List;
